import Vue from 'vue'
import {
  Button,
  Form,
  FormItem,
  Input,
  Message,
  Dialog,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItemGroup,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  Loading,
  RadioGroup,
  RadioButton,
  Tag,
  Tooltip,
  MessageBox,
  Pagination,
  Select,
  Option,
  DatePicker,
  TimePicker,
  Popconfirm,
  Popover,
  Avatar,
  Carousel,
  CarouselItem,
  Slider,
  CheckboxGroup,
  CheckboxButton,
  Checkbox,
  Upload,
  Tabs,
  TabPane,
  Cascader,
  Transfer,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Image,
  Divider,
  Progress,
  TimeSelect,
} from 'element-ui'

Vue.use(Button)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Dialog)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Loading)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Tag)
Vue.use(Tooltip)
Vue.use(Pagination)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Popconfirm)
Vue.use(Popover)
Vue.use(Avatar)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Slider)
Vue.use(CheckboxGroup)
Vue.use(CheckboxButton)
Vue.use(Checkbox)
Vue.use(Upload)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Cascader)
Vue.use(Transfer)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Image)
Vue.use(Divider)
Vue.use(Progress)
Vue.use(TimeSelect)


Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
